<script>
  import Form from "../../components/Form.svelte";
  import { makeApiRequest } from "../../utils/ajax";
  import { router } from "@inertiajs/svelte";

  let { title, loadSocialProfiles } = $props();

  let savingSocialProfile = $state(false);
  let serverErrors = $state(null);

  let saveSocialProfile = async (data) => {
    savingSocialProfile = true;

    const resp = await makeApiRequest("/api/social_profiles", {
      social_profile: data,
    });

    if (resp.success === false) {
      serverErrors = resp;
    } else {
      loadSocialProfiles();
      goToSocialProfile(resp.id);
    }

    savingSocialProfile = false;
  };

  let goToSocialProfile = (id) => {
    router.get(`/dashboard/social_profiles/${id}`);
  };
</script>

<Form
  {title}
  description="Connect your social media account to start tracking your performance."
  submitText="Add Profile"
  loading={savingSocialProfile}
  processingText="Scanning profile..."
  fields={[
    {
      name: "platform",
      label: "Platform",
      type: "select",
      required: true,
      options: [
        { value: "instagram", label: "Instagram" },
        { value: "tiktok", label: "TikTok" },
      ],
    },
    {
      name: "username",
      label: "Username",
      type: "text",
      required: true,
      placeholder: "Enter your username (without @)",
      helpText: "Just the username, not the full URL",
    },
  ]}
  {serverErrors}
  onSubmit={(data) => {
    saveSocialProfile(data);
  }} />
